"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcTableSelectorCell = void 0;
var React = __importStar(require("react"));
var AcTableSelectorCell_module_scss_1 = __importDefault(require("./AcTableSelectorCell.module.scss"));
var AcTableContext_1 = require("./AcTableContext");
var AcTableSelectorCell = function (props) {
    var _a;
    var item = props.item, enableSelector = props.enableSelector, data = props.data, functionContext = props.functionContext;
    var _b = AcTableContext_1.useAcTableContext(), selectedDataIds = _b.selectedDataIds, deselectRow = _b.deselectRow, selectRow = _b.selectRow, isSelectorDisabled = _b.isSelectorDisabled;
    var selected = (selectedDataIds === null || selectedDataIds === void 0 ? void 0 : selectedDataIds.indexOf((_a = item === null || item === void 0 ? void 0 : item.data) === null || _a === void 0 ? void 0 : _a.id)) !== -1;
    var onClick = function () {
        if (selected) {
            deselectRow === null || deselectRow === void 0 ? void 0 : deselectRow(item === null || item === void 0 ? void 0 : item.data);
        }
        else if (!isSelectorDisabled) {
            selectRow === null || selectRow === void 0 ? void 0 : selectRow(item === null || item === void 0 ? void 0 : item.data);
        }
    };
    if (enableSelector && !enableSelector(data, functionContext)) {
        return React.createElement("div", { className: " " + AcTableSelectorCell_module_scss_1.default.container + " " });
    }
    return (React.createElement("div", { className: " " + AcTableSelectorCell_module_scss_1.default.container + " " },
        React.createElement("div", { className: "custom-control custom-checkbox " + AcTableSelectorCell_module_scss_1.default.checkDiv, onClick: onClick },
            React.createElement("input", { type: "checkbox", className: "custom-control-input", checked: selected, disabled: !selected && isSelectorDisabled, readOnly: true }),
            React.createElement("label", { className: "custom-control-label " + AcTableSelectorCell_module_scss_1.default.checkLabel }))));
};
exports.AcTableSelectorCell = AcTableSelectorCell;
exports.AcTableSelectorCell.displayName = 'AcTableSelectorCell';
//# sourceMappingURL=AcTableSelectorCell.js.map